import httpClient from './httpClient';

export const fetchMyWeeklyReport = (weekStart) => {
  const params = weekStart ? { weekStart } : {};
  return httpClient.get('/weekly-reports/me', { params }).then((response) => response.data);
};

export const submitWeeklyReport = (payload) =>
  httpClient.post('/weekly-reports', payload).then((response) => response.data);

export const fetchTutorWeeklyReport = (tutorId, weekStart) => {
  const params = weekStart ? { weekStart } : {};
  return httpClient
    .get(`/weekly-reports/tutor/${tutorId}`, { params })
    .then((response) => response.data);
};



